import * as React from 'react';
export const IcSaturation = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 2a10 10 0 100 20 10 10 0 000-20zm4 6.69l-1.24 3.1A1.91 1.91 0 0113.32 13c-.13.015-.26.015-.39 0a1.89 1.89 0 01-1.36-.57 1.92 1.92 0 01.64-3.15L15.31 8a.5.5 0 01.65.65l.04.04z'
      fill='currentColor'
    />
  </svg>
);
